import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add secret key
apiClient.interceptors.request.use(
  (config) => {
    const secretKey = localStorage.getItem('secretKey') || localStorage.getItem('terminalSecretKey');
    if (secretKey) {
      config.headers.Authorization = `Bearer ${secretKey}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('secretKey');
      localStorage.removeItem('workstationInfo');
      localStorage.removeItem('terminalSecretKey');
      localStorage.removeItem('terminalInfo');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (secretKey) =>
    apiClient.post('/terminal/queue/auth', { terminal_secret_key: secretKey }),

  logout: () => {
    localStorage.removeItem('secretKey');
    localStorage.removeItem('workstationInfo');
    localStorage.removeItem('terminalSecretKey');
    localStorage.removeItem('terminalInfo');
  }
};

// Queue API
export const queueAPI = {
  getQueue: () => apiClient.get('/terminal/queue'),
  getQueueItem: (id) => apiClient.get(`/terminal/queue/${id}`),
  updateQueueItem: (id, data) => apiClient.patch(`/terminal/queue/${id}`, data)
};

export default apiClient;
